import type { ReactElement } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import { LOUNGE_PASSES_PAGE } from 'loyalty/constants/loyaltyRoutes'

interface Props {
  layout: 'tile' | 'row'
  benefitLabel: ReactElement
}

function LandingPageLoyaltyLoungePass(props: Props) {
  const { layout, benefitLabel } = props
  const intl = useIntl()

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="lounge_pass"
    heading={intl.formatMessage({
      id: 'c9p-4SjsKWKqzrAh-aoA',
      defaultMessage: 'Free airport lounge passes',
      description: 'Heading for loyalty airport lounge pass benefit tile',
    })}
    subtitle={benefitLabel}
    to={`/${LOUNGE_PASSES_PAGE}`}
  />
}

export default LandingPageLoyaltyLoungePass
